// Telefoonnummer-helpers — normaliseert naar +E164 (NL-standaard bij ontbrekende landcode).
export function normalizePhone(raw) {
  if (!raw) return "";
  let p = String(raw).trim().replace(/[\s\-().]/g, "");
  if (p.startsWith("00")) p = "+" + p.slice(2);
  if (p.startsWith("0")) p = "+31" + p.slice(1);
  if (!p.startsWith("+")) p = "+" + p;
  return p;
}

// Geldig internationaal nummer: + gevolgd door 8–15 cijfers.
export function isValidPhone(raw) {
  if (!raw) return true; // leeg mag (optioneel veld)
  const p = normalizePhone(raw);
  return /^\+[1-9]\d{7,14}$/.test(p);
}
